<div class="selector-div-wrapper">
  <span>Display Level</span>

  <!-- New association switch, btn group radio switch -->
  <div class="d-flex justify-content-center">
    <div class="btn-group text-center" role="group" aria-label="Basic radio toggle button group">

      <input 
        type="radio" 
        class="btn-check" 
        name="mode" 
        id="mode-filter"
        autocomplete="off" 
        (change)="switchDisplayLevel('sections')"
        [checked]="tool.layerLevel === 'sections'">

      <label class="btn-group-option" for="mode-filter">Sections</label>

      <input 
        type="radio" 
        class="btn-check" 
        name="mode" 
        id="mode-views" 
        autocomplete="off"
        (change)="switchDisplayLevel('seats')" 
        [checked]="tool.layerLevel === 'seats'">

      <label class="btn-group-option" for="mode-views">Seats</label>

    </div>
  </div>

</div>